import { DayOfWeekEnum, ProviderPaymentDateRuleDTO, StrategyCode, TriggerSource } from '../types';

const STRATEGY_LABEL: Record<StrategyCode, string> = {
	[StrategyCode.NetDays]: 'Días netos',
	[StrategyCode.SplitMonth]: 'Corte mensual',
	[StrategyCode.MonthlyRelative]: 'Mensual relativo',
	[StrategyCode.WeeklyRelative]: 'Semanal relativo',
	[StrategyCode.CustomCalendar]: 'Calendario personalizado',
};

const TRIGGER_LABEL: Record<TriggerSource, string> = {
	[TriggerSource.ServiceCreation]: 'Creación del servicio',
	[TriggerSource.CheckIn]: 'Inicio del servicio (check-in)',
	[TriggerSource.CheckOut]: 'Fin del servicio (check-out)',
};

const DOW_LABEL: Record<DayOfWeekEnum, string> = {
	[DayOfWeekEnum.Monday]: 'Lunes',
	[DayOfWeekEnum.Tuesday]: 'Martes',
	[DayOfWeekEnum.Wednesday]: 'Miércoles',
	[DayOfWeekEnum.Thursday]: 'Jueves',
	[DayOfWeekEnum.Friday]: 'Viernes',
	[DayOfWeekEnum.Saturday]: 'Sábado',
	[DayOfWeekEnum.Sunday]: 'Domingo',
};

export interface PaymentRuleSummaryField {
	label: string;
	value: string;
}

export const buildPaymentRuleSummary = (rule: ProviderPaymentDateRuleDTO | null): PaymentRuleSummaryField[] => {
	if (!rule) {
		return [{ label: 'Estado', value: 'Sin regla configurada' }];
	}

	const config = rule.configuration as Record<string, unknown>;
	const fields: PaymentRuleSummaryField[] = [
		{ label: 'Estrategia', value: STRATEGY_LABEL[rule.strategyCode] ?? rule.strategyCode },
	];

	if (config.triggerSource) {
		fields.push({
			label: 'Disparador',
			value: TRIGGER_LABEL[config.triggerSource as TriggerSource] ?? String(config.triggerSource),
		});
	}

	switch (rule.strategyCode) {
		case StrategyCode.NetDays:
			if (config.days !== undefined) {
				fields.push({ label: 'Días netos', value: String(config.days) });
			}
			break;
		case StrategyCode.SplitMonth:
			if (config.cutoffDay !== undefined) {
				fields.push({ label: 'Día de corte', value: String(config.cutoffDay) });
			}
			break;
		case StrategyCode.MonthlyRelative:
			if (config.monthOffset !== undefined) fields.push({ label: 'Mes offset', value: String(config.monthOffset) });
			if (config.dayOfWeek)
				fields.push({ label: 'Día de la semana', value: DOW_LABEL[config.dayOfWeek as DayOfWeekEnum] });
			if (config.weekOrdinal !== undefined)
				fields.push({ label: 'Ordinal de semana', value: String(config.weekOrdinal) });
			break;
		case StrategyCode.WeeklyRelative:
			if (config.weeksOffset !== undefined) fields.push({ label: 'Semanas offset', value: String(config.weeksOffset) });
			if (config.dayOfWeek)
				fields.push({ label: 'Día de la semana', value: DOW_LABEL[config.dayOfWeek as DayOfWeekEnum] });
			break;
		case StrategyCode.CustomCalendar: {
			const periods = (config.periods as Array<{ from: string; to: string; dueDate: string }>) ?? [];
			fields.push({ label: 'Períodos personalizados', value: `${periods.length} período(s)` });
			break;
		}
		default:
			break;
	}

	return fields;
};
